import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MaterialModule } from './material.module';
import { SharedModule } from '../shared/shared.module';

import { MenuAuditoriaComponent } from '@components/pages/auditoria/menu-auditoria/menu-auditoria.component';
import { AuditoriaListadoComponent } from '@components/pages/auditoria/auditoria-listado/auditoria-listado.component';
import { AuditoriaDetalleComponent } from '@components/pages/auditoria/auditoria-detalle/auditoria-detalle.component';

@NgModule({
    declarations: [
        MenuAuditoriaComponent,
        AuditoriaListadoComponent,
        AuditoriaDetalleComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        MaterialModule,
        SharedModule,
    ],
})
export class AuditoriaModule {}
